import React from 'react';

interface SvgProps {
    fill?: string;
    width?: number;
    height?: number;
    className?: string;
    svgContent?: string;
}

export const Svg: React.FC<SvgProps> = ({ fill = 'currentColor', width = 20, height = 20, className, svgContent }: SvgProps) => {

    if (!svgContent) {
        console.error('Conteúdo SVG não fornecido');
        return null;
    }

    return (
        <svg
            className={className}
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill}
            width={width}
            height={height}
            viewBox="0 0 200 200" 
            dangerouslySetInnerHTML={{ __html: svgContent }}
        />
    );
};
